<template>
  <div>
    <page-title>Dashboard</page-title>
    <b-loading :is-full-page="true" :active.sync="$apollo.loading" :can-cancel="false"></b-loading>
    <div class="columns flex-row wrap justify-space-evenly">
      
      <div  class="column">
        <DashboardCard
          title="Awaiting Review Applications"
          :data="shippingRequestReport.awaiting_processing_shipping_requests || 0"
          link="review-applications"
        ></DashboardCard>
      </div>

      <div class="column">
        <DashboardCard
          title="Accepted Applications"
          :data="shippingRequestReport.pending_approval_shipping_requests || 0"
          link="accepted-applications"
        ></DashboardCard>
      </div>

      <div  class="column">
        <DashboardCard
          title="Denied Applications"
          :data="shippingRequestReport.failed_processing_shipping_requests || 0"
          link="rejected-applications"
        ></DashboardCard>
      </div>
    </div>
    <div class="columns">

      <!-- Main Agent Links -->
      <div  class="column">
        <DashboardCard
          title="Review Applications"
          hasBg
          link="review-applications"
        ></DashboardCard>
      </div>
      <div class="column">
        <DashboardCard
          title="Read Guide"
          hasBg
          link="nimasa-agent-guide"
        ></DashboardCard>
      </div>
    </div>
    <!-- <div class="columns is-multiline is-centered">
      <div class="column is-12">
        <bar-chart :chartdata="chartData"></bar-chart>
      </div>
    </div> -->
  </div>
</template>

<script>
import DashboardCard from "../components/DashboardCard.vue";
import BarChart from "../components/BarChart.vue";
import GetShippingRequestReport from "@/modules/nimasaAgentModule/api/graphql/queries/GetShippingRequestReportsForNimasa.gql";
import * as moment from "moment";
import { createNamespacedHelpers } from "vuex";
const { mapGetters, mapMutations } = createNamespacedHelpers("nimasaAgent");
import {
  mapGetters as mapRootGetters,
  mapMutations as mapRootMutations
} from "vuex";
import { ROOT_MUTATION_TYPES } from "@/store/mutation-types.js";
import GetPortsQuery from "@/modules/commonModule/api/graphql/queries/GetPorts";


export default {
  name: "dashboard",
  components: { DashboardCard, BarChart },
  apollo: {
    shippingRequestReport: {
      query: GetShippingRequestReport,
      variables() {
        return {
          start_date: moment("2019-01-01", "YYYY-MM-DD").format("YYYY-MM-DD"),
          end_date: moment(new Date(), "YYYY-MM-DD").format("YYYY-MM-DD")
        };
      },
      update: data => data.getShippingRequestsReportForNimasa
    }
  },
  data() {
    return {
      chartData: {
        labels: ["January", "February", "March", "April"],
        datasets: [
          {
            label: "Dangerous Goods Requests",
            backgroundColor: "#f87979",
            data: [40, 20, 48, 80, 0]
          }
        ]
      },
      shippingRequestReport: {}
    };
  },
  created: function() {
    if (!this.portsFromVuex.loaded) {
      this.loadPortsFromAPI();
    }
  },
  computed: {
    ...mapRootGetters({
      portsFromVuex: "getPorts",
    }),
    ...mapGetters({
      isNimasaAgent: "isNimasaAgent",
      isNimasaManager: "isNimasaManager"
    })
  },
  methods: {
    
    ...mapRootMutations({
      updatePorts: ROOT_MUTATION_TYPES.SAVE_PORTS
    }),


    loadPortsFromAPI: function() {
      this.isLoading = true;

      this.$apollo
        .query({
          query: GetPortsQuery
        })
        .then(response => {
          const ports = response.data.ports;
          this.updatePorts(ports);
        })
        .catch(error => {
          this.$toast.open({
            duration: 4000,
            message: "Failed to load list of ports",
            type: "is-danger"
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  }
};
</script>

<style scoped>
.card {
  margin: 1em;
  min-height: 130px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  align-items: center;
  text-align: center;
  border: 1px solid #6e98ff;
  box-shadow: 0px 0px 20px 1px #ccc;
}

.level {
  justify-content: space-evenly !important;
}

.flex-wrap {
  flex-wrap: wrap !important;
}
.dashboard-card {
  width: 50%;
}

.columns {
  display: flex;
  justify-content: center;
  align-items: center;
}

.bgColor {
  background-color: #000;
  border: none !important;
}
</style>

